module.exports = __webpack_public_path__ + "img/trip(18).11c1178f.webp";